import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { reportError } from '@/domains/observability'

import { markInvoicesPaid } from './api'
import { useInvalidateInvoices } from './use-invalidate-invoices'

export function useMarkInvoicesPaid() {
  const invalidate = useInvalidateInvoices()
  return useMutation({
    mutationFn: (ids: string[]) => markInvoicesPaid(ids),
    onSuccess: result => {
      invalidate()
      toast.success(
        result.updated === 1
          ? 'Invoice marked as paid'
          : `${result.updated} invoices marked as paid`
      )
    },
    onError: error => {
      reportError(error)
      toast.error('Failed to mark as paid')
    }
  })
}
